import Pdf from "./other/2312.05688.pdf";
import Pdf2 from "./other/EMCONA_1.pdf";
import Pdf3 from "./other/em3_justified_CR.pdf";
import Pdf4 from "./other/efficiency_acl_paper_arxiv.pdf";

const PreprintData = [
    {
      authors: "Gagan Bhatia, Yamen Ajjour, Lotta Kiefer, Christoph Leiter, Elena Schmidt, Steffen Eger",
      title:
        "The Quality–Efficiency Frontier in Authorship Verification: When Are LLMs Worth the Cost?",
      venue: "Preprint, 2026",
      code: "https://nl2g.github.io",
      paper: Pdf4,
      abstract: (
        <p> 
          Authorship verification (AV) plays a central role in trust and safety applications, where high-stakes decisions and large volumes of text demand both accuracy and efficiency. 
          Yet AV research has focused primarily on predictive quality, leaving unanswered whether the improvements offered by large language models (LLMs) justify their training and inference costs. 
          We address this gap by introducing TrainAVUE and InferAVUE, two measures that relate retained F1 gains to measured time and memory. 
          We compare 10 LLMs with 11 non-LLM methods and evaluate 19 training configurations and 17 inference-efficiency techniques on five LLMs across two English and two German benchmarks. 
          Fine-tuned LLMs outperform the strongest non-LLM methods by 10-19 F1 points; QLoRA can reduce training memory by 55% at comparable F1, while token pruning can reduce inference latency by 38% while retaining 97.8% of F1. 
          However, these gains come at different costs: on long documents, the first improvement over non-LLM methods requires 7.4-9.3x higher latency for only 0.02-0.03 additional F1. 
          Our findings show that LLM-based AV offers more favorable quality-efficiency trade-offs on short texts, while non-LLM methods remain competitive for longer inputs.
        </p>
      ),
    },
    {
    authors: "Yanran Chen, Steffen Eger",
    title:
      "Justification of Emotional Appeal in Computational Argumentation",
    venue: "EMNLP 2026 Main",
    code: "https://nl2g.github.io",
    paper: Pdf3,
    abstract: (
      <p> 
        Emotional appeals (EAs) are often treated as fallacious in computational
        argumentation, yet they may be justified when warranted by the context. We
        introduce the task of predicting EA justification and present the first
        human-annotated dataset for this task, covering 1,176 argument--context pairs.
        Grounded in philosophical literature, our framework evaluates EA justification
        along logical and emotional dimensions. Human annotations show that
        justification criteria form a shared latent judgment space, with evidential
        proportionality and normative acceptability most strongly associated with
        overall justification. We further find that EAs without logical support are not
        always judged fully unjustified, and stronger EAs are not necessarily judged
        less justified. Finally, LLM experiments show that EA justification prediction
        remains challenging.
      </p>
    ),
  },
  {
    authors: "Yanran Chen, Steffen Eger",
    title: " Do Emotions Really Affect Argument Convincingness? A Dynamic Approach with LLM-based Manipulation Checks",
    venue: "Preprint, 2025",
    paper: Pdf2,
    code: "https://nl2g.github.io",
    abstract: (
      <p>Emotions have been shown to play a role in argument convincingness, yet this aspect is underexplored in the natural language 
        processing (NLP) community. Unlike prior studies that use static analyses, focus on a single text domain or language, or treat
         emotion as just one of many factors, we introduce a dynamic framework inspired by manipulation checks commonly used in 
         psychology and social science; leveraging LLM-based manipulation checks, this framework examines the extent to which perceived 
         emotional intensity influences perceived convincingness. Through human evaluation of arguments across different languages, 
         text domains, and topics, we find that in over half of cases, judgments of convincingness remain unchanged despite variations 
         in perceived emotional intensity; when emotions do have an impact, they more often enhance rather than weaken convincingness. 
         We further analyze how 11 LLMs behave in the same scenario, finding that while LLMs generally mirror human patterns, they 
         struggle to capture nuanced emotional effects in individual judgments.</p>
    )
  },
  {
    authors: "Ran Zhang, Aida Kostikova, Christoph Leiter, Jonas Belouadi, Daniil Larionov, Yanran Chen, Vivian Fresen, Steffen Eger",
    title: "NLLG Quarterly arXiv Report 09/23: What are the most influential current AI Papers?",
    venue: "Arxiv, 2023",
    paper: Pdf,
    code: "https://nl2g.github.io",
    abstract: (
      <p>Artificial Intelligence (AI) has witnessed rapid growth, especially in the subfields Natural Language Processing (NLP),
        Machine Learning (ML) and Computer Vision (CV). Keeping pace with this rapid progress poses a considerable challenge for
        researchers and professionals in the field. In this arXiv report, the second of its kind, which covers the period from
        January to September 2023, we aim to provide insights and analysis that help navigate these dynamic areas of AI. We accomplish
        this by 1) identifying the top-40 most cited papers from arXiv in the given period, comparing the current top-40 papers
        to the previous report, which covered the period January to June; 2) analyzing dataset characteristics and keyword
        popularity; 3) examining the global sectoral distribution of institutions to reveal differences in engagement across
        geographical areas. Our findings highlight the continued dominance of NLP: while only 16% of all submitted papers have
        NLP as primary category (more than 25% have CV and ML as primary category), 50% of the most cited papers have NLP as
        primary category, 90% of which target LLMs. Additionally, we show that i) the US dominates among both top-40 and top-9k papers,
        followed by China; ii) Europe clearly lags behind and is hardly represented in the top-40 most cited papers; iii) US industry
        is largely overrepresented in the top-40 most influential papers. </p>
    )
  },
];

export default PreprintData;
